/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
/**
 * @type EmailAddress
 *
 * @export
 */
export type EmailAddress = string;

export function EmailAddressFromJSON(json: any): EmailAddress {
  return EmailAddressFromJSONTyped(json, false);
}

export function EmailAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailAddress {
  if (json == null) {
    return json;
  }
  if (typeof json === "string") {
    return json;
  }
  if (typeof json === "string") {
    return json;
  }
  return {} as any;
}

export function EmailAddressToJSON(json: any): any {
  return EmailAddressToJSONTyped(json, false);
}

export function EmailAddressToJSONTyped(
  value?: EmailAddress | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }
  if (typeof value === "string") {
    return value;
  }
  if (typeof value === "string") {
    return value;
  }
  return {};
}
